import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from './e9ddd2f338caa1d50c0890aa93313190bf1d0ffbca6850e0ef678074f1f1e039.cfe-internal.js';
import { RadioGroupContextProvider } from './dc2dcd19156b71f7876c04b437232bc71c237257519b4d21de74e3f9b9474ebe.cfe-internal.js';

var _excluded = ["className", "label", "name", "defaultValue", "value", "onChange", "children"];
var RadioGroup = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    label = _ref.label,
    name = _ref.name,
    defaultValue = _ref.defaultValue,
    value = _ref.value,
    onChange = _ref.onChange,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var classes = classNames(className, styles.radioGroup);
  return /*#__PURE__*/React__default.createElement(RadioGroupContextProvider, {
    value: {
      name: name,
      onChange: onChange,
      groupDefaultValue: defaultValue,
      groupValue: value
    }
  }, /*#__PURE__*/React__default.createElement("fieldset", _extends({}, rest, {
    ref: ref,
    className: classes
  }), /*#__PURE__*/React__default.createElement("legend", {
    className: styles.legend
  }, label), children));
});

export { RadioGroup as default };
